import React from 'react';

// Reusable ornamental section heading
export default function SectionHeading({ eyebrow, title, subtitle, light = false }) {
  const titleColor = light ? 'text-[#f2d68a]' : 'text-[#7c130f]';
  const eyebrowColor = light ? 'text-[#e2b84f]' : 'text-[#a4761b]';
  const subColor = light ? 'text-[#f4e6c8]' : 'text-[#7c4a20]';

  return (
    <div className="text-center max-w-2xl mx-auto">
      {eyebrow && (
        <p className={`reveal font-heading tracking-[0.4em] uppercase text-sm ${eyebrowColor}`}>
          {eyebrow}
        </p>
      )}
      <div className="reveal flex items-center justify-center gap-3 mt-3" data-delay="80">
        <span className="h-[1.5px] w-10 bg-[#c9962e]" />
        <span className="text-[#c9962e] text-xl">&#10022;</span>
        <span className="h-[1.5px] w-10 bg-[#c9962e]" />
      </div>
      <h2
        className={`reveal font-display font-bold text-3xl sm:text-4xl md:text-5xl leading-[1.15] mt-3 px-2 ${titleColor}`}
        data-delay="120"
        style={{ textWrap: 'balance' }}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`reveal font-body italic text-lg md:text-xl mt-4 ${subColor}`} data-delay="180">
          {subtitle}
        </p>
      )}
    </div>
  );
}
